import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import AuthStore from './auth.store';

export const store = new Vuex.Store({
    state: {
        apiServer: process.env.VUE_APP_API_SERVER,
        sessionId: null,
        sessionName: null,
        allowVideo: process.env.VUE_APP_USE_VIDEO.trim().toLowerCase() == 'true' ? true : false,
        hostNumber: 1,
        joinedSession: false,
        isRecording: false,
        audioContext: null,
    },

    modules: {
        auth: AuthStore,
    },

    mutations: {
        SESSION_ID(state, id) {
            state.sessionId = id;
        },

        SESSION_NAME(state, s) {
            state.sessionName = s;
        },

        HOST_NUMBER(state, n) {
            state.hostNumber = n;
        },

        JOINED_SESSION(state, b) {
            state.joinedSession = b;
        },

        IS_RECORDING(state, b) {
            state.isRecording = Boolean(b);
        },

        AUDIO_CONTEXT(state, value) {
            state.audioContext = value;
        }
    },

    getters: {
        isAdmin(state) {
            return state.auth.user && state.auth.user.isAdmin;
        },

        token(state) {
            return state.auth.token;
        },

        user(state) {
            return state.auth.user;
        },

        isRecording(state) {
            return state.isRecording;
        },

        audioContext(state) {
            return state.audioContext;
        },

        role(state) {
            return state.auth.user && state.auth.user.role;
        },

        sessionId(state) {
            return state.sessionId;
        },

        sessionName(state) {
            return state.sessionName;
        }
    },

    actions: {
        joinSession({ rootGetters, commit }, sessionId) {
            if (rootGetters['auth/isHost']) {          // producer can change session, guests have it set in their token
                commit('SESSION_ID', sessionId);
            }

            commit('JOINED_SESSION', true);
        },

        leaveSession() {
            location.href = '';
        },
    },
});
